<script setup lang="ts">
import type { MainMenuSubmenuProps } from './MainMenu.types';

defineProps<
  MainMenuSubmenuProps & {
    isOpen?: boolean;
  }
>();
</script>

<template>
  <div v-if="isOpen" class="main-menu__sub-menu">
    <slot />
  </div>
</template>

<style lang="scss"></style>
